import React, { FC } from 'react';

import { EDataTestId } from '@webtrader/core/constants/test';
import { useTranslation } from '@webtrader/core/i18n';
import { isValidOtp } from '@webtrader/core/validators';

import ValidationError from '@/components/FormValidationError';
import TextInput from '@/components/TextInput';

import { EmailVerificationFieldRowItem, FormFieldRow } from '../Styles';
import RequestOtpButton from './request-otp-button';

interface ISignUpEmailVerification {
  otp: string | undefined;
  onOtpChange: (otp: string) => void;
  submitting: boolean | undefined;
  showValidation: boolean;
  email: string | undefined;
}
const SignUpEmailVerification: FC<ISignUpEmailVerification> = ({
  otp,
  onOtpChange,
  submitting,
  showValidation,
  email
}) => {
  const { t } = useTranslation();
  return (
    <>
      <FormFieldRow>
        <EmailVerificationFieldRowItem>
          <TextInput
            label={t('Email Verification Code')}
            value={otp}
            onChangeText={onOtpChange}
            placeholder={t('Enter email verification code')}
            editable={!submitting}
            testID={EDataTestId.SIGN_UP_OTP}
          />
        </EmailVerificationFieldRowItem>
        <EmailVerificationFieldRowItem isLast={true}>
          <RequestOtpButton isFormSubmitting={submitting} email={email} />
        </EmailVerificationFieldRowItem>
      </FormFieldRow>
      <ValidationError
        showValidation={showValidation}
        message={
          otp && !isValidOtp(otp)
            ? t('Email verification code must be exactly 6 digits')
            : t('Email verification code is required')
        }
      />
    </>
  );
};

export default SignUpEmailVerification;
